export const GET_NOTIFICATIONS = "GET_NOTIFICATIONS";
export const SET_NOTIFICATIONS = "SET_NOTIFICATIONS";
export const REFRESH_NOTIFICATIONS = "REFRESH_NOTIFICATIONS";
